import React from 'react';
import { Section as SectionDI, SkeletonItem as SkeletonItemDI } from '@atlaskit/side-navigation';
import { fg } from '@atlassian/jira-feature-gating';
import { useBoard } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/board/index.tsx';
import { useIntlV2 as useIntlDI } from '@atlassian/jira-intl/src/v2/use-intl.tsx';
import { MenuItem as MenuItemDI } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/menu-item/main.tsx';
import { useProject as useProjectDI } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/project/index.tsx';
import { withThrowOnError } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/throw-when-no-data-and-error/index.tsx';
import { matchUrlParams as matchUrlParamsDI } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/url-matchers/index.tsx';
import { ConnectMenu as ConnectMenuDI } from '@atlassian/jira-navigation-apps-sidebar-connect/src/common/ui/connect-menu/main.tsx';
import { messages } from './messages.tsx';
import type { OtherReportsProps } from './types.tsx';

const useThrowProjectDI = withThrowOnError(useProjectDI);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default ({
	MenuItem = MenuItemDI,
	Section = SectionDI,
	SkeletonItem = SkeletonItemDI,
	useIntl = useIntlDI,
	useProject = useThrowProjectDI,
	ConnectMenu = ConnectMenuDI,
	matchUrlParams = matchUrlParamsDI,
	connectItems,
}: OtherReportsProps) => {
	const { formatMessage } = useIntl();
	const { data: project } = useProject();
	const { data: board, loading: isBoardLoading, error } = useBoard();

	if (project == null) return <SkeletonItem />;
	if (isBoardLoading && fg('reports-overview-page-migration')) return <SkeletonItem />;

	const newReportsHref =
		board == null && !isBoardLoading && !error
			? `/jira/software/c/projects/${project.key}/reports`
			: `/jira/software/c/projects/${project.key}/boards/${board?.id}/reports`;

	const reportsHref = fg('reports-overview-page-migration')
		? newReportsHref
		: `/projects/${project.key}?selectedItem=com.atlassian.jira.jira-projects-plugin:report-page`;

	const BackMenuItem = {
		href: reportsHref,
		title: formatMessage(messages.backItem),
	};

	return (
		<Section title={formatMessage(messages.other)}>
			<MenuItem
				analytics={{ itemId: 'workload-pie' }}
				selectedOn={matchUrlParams(['reportKey'])}
				href={`/secure/ConfigureReport!default.jspa?selectedProjectId=${project.id}&projectOrFilterId=project-${project.id}&projectOrFilterName=${project.name}&reportKey=com.atlassian.jira.ext.charting:workloadpie-report`}
			>
				{formatMessage(messages.workloadPieChart)}
			</MenuItem>
			<ConnectMenu items={connectItems} overrides={{ BackMenuItem }} />
		</Section>
	);
};
